module.exports = __webpack_public_path__ + "img/surfclub_hair.fdb0cdc0.jpg";